import { LOCALE_ID, Pipe, PipeTransform, inject } from "@angular/core";

@Pipe({
  standalone: true,
  name: "localizeDate",
})
export class LocalizeDatePipe implements PipeTransform {
  private localeId = inject(LOCALE_ID);

  transform(date: Date): string {
    return date.toLocaleDateString(this.localeId);
  }
}
